import React from "react"
import {Box, Tab, Tabs, Typography} from "@mui/material"
import MailOutlineIcon from "@mui/icons-material/MailOutline"
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined"
import {format} from "date-fns"

import type {CaseConversationSummary} from "@indebted/api"

function isSMS(summary: CaseConversationSummary): boolean {
	return summary.channel === "sms"
}

function channelLabel(summary: CaseConversationSummary): string {
	return isSMS(summary) ? "SMS" : "Email"
}

// An SMS thread has no subject to head the tab with, so the channel line is the
// whole label; an email tab keeps the subject above it.
function threadLabel(summary: CaseConversationSummary): string {
	if (isSMS(summary)) return ""
	return summary.subject.trim() === "" ? "Conversation" : summary.subject
}

function formatLastActivity(lastActivityAt: string): string {
	return format(new Date(lastActivityAt), "d MMM yyyy, HH:mm")
}

function ThreadTabs({
	summaries,
	selectedConversationID,
	onSelect,
}: {
	summaries: CaseConversationSummary[]
	selectedConversationID: string
	onSelect: (id: string) => void
}) {
	return (
		<Tabs
			value={selectedConversationID}
			onChange={(_, id: string) => onSelect(id)}
			variant="scrollable"
			scrollButtons="auto"
			sx={{mb: 2}}
		>
			{summaries.map((summary) => {
				const label = threadLabel(summary)
				return (
					<Tab
						key={summary.id}
						value={summary.id}
						icon={
							isSMS(summary) ? <SmsOutlinedIcon fontSize="small" /> : <MailOutlineIcon fontSize="small" />
						}
						iconPosition="start"
						sx={{textTransform: "none", alignItems: "center", minHeight: 56, maxWidth: 320}}
						label={
							<Box textAlign="left" minWidth={0}>
								{label !== "" && (
									<Typography variant="body2" color="textPrimary" noWrap>
										{label}
									</Typography>
								)}
								<Typography variant="caption" color="textSecondary" component="div" noWrap>
									{channelLabel(summary)} · {formatLastActivity(summary.lastActivityAt)}
								</Typography>
							</Box>
						}
					/>
				)
			})}
		</Tabs>
	)
}

export {ThreadTabs}
